import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import PageNotFound from "../components/View/PageNotFound";
import { Wrapper } from "../utils/RolesandAccess";
import MainStandardSettings from '../pages/StandardSettings/MainStandardSettings';
import { ApprovalStatusIndex, EmailTemplateIndex, FrequencyIndex, IncidentIndex, InternalAuditDefinitionIndex, ManualStatusIndex, StatusIndex, VendorIndex } from '../pages/StandardSettings';


function StandardSettingsRoutes() {
      const { stdId } = useParams();
      const location = useLocation();
      const navigate = useNavigate();

        useEffect(() => {
      
          if (location.pathname === `/standard/${stdId}/settings/`||location.pathname === `/standard/${stdId}/settings`) {
            navigate(`/standard/${stdId}/settings/status`, { replace: true });
          }
        }, [location.pathname, stdId, navigate]);
  return (
   <Routes>
    <Route path="/" element={<Wrapper accessKey={stdId} Component={MainStandardSettings} />}>
      <Route path="status" element={<Wrapper accessKey={stdId} Component={StatusIndex} />}/>
      <Route path="frequency" element={<Wrapper accessKey={stdId} Component={FrequencyIndex} />}/>
      <Route path="vendor-type" element={<Wrapper accessKey={stdId} Component={VendorIndex} />}/>
      <Route path="incident-type" element={<Wrapper accessKey={stdId} Component={IncidentIndex} />}/>
      <Route path="manual-status" element={<Wrapper accessKey={stdId} Component={ManualStatusIndex} />}/>
      <Route path="approval-status" element={<Wrapper accessKey={stdId} Component={ApprovalStatusIndex} />}/>
      <Route path="internal-audit-definition" element={<Wrapper accessKey={stdId} Component={InternalAuditDefinitionIndex} />}/>
      <Route path="email-templates" element={<Wrapper accessKey={stdId} Component={EmailTemplateIndex} />}/>
    </Route>
    <Route path="/*" element={<PageNotFound/>} />
   </Routes>
  )
}

export default StandardSettingsRoutes;
